/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import Icons from '@/components/icons'
import useIsMobile from '@/hooks/useIsMobile'
import { copyToClipboard } from '@/lib/utilities/Utils'
import React, { useState } from 'react'
// import { useSelector } from 'react-redux'
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share'

interface StoreSocialShareProps {
  shop: {
    rating: number
    isPremium: boolean
    isGreatOffer: boolean
    isTrending: boolean
    isWideVariety: boolean
    isBestRated: boolean
    isNewlyOpened: boolean
    isFreeSample?: boolean
    country?: string
    city?: string
    locality?: string
    storeType: {
      name?: string
      displayName?: string
    }
    name?: string
    displayName?: string
    storeId?: number
    code?: number
    logo?: string
    shopImagePlaceholder?: string
    productTransferMode: {
      homeDelivery: boolean
      storePickup: boolean
    }
    averageDeliveryTimeString: string
    calculatedDistanceMeasurement: string
    calculatedDistance: number
    offerText: string
  }
}

function StoreSocialShare ({ shop }: StoreSocialShareProps): JSX.Element {
  // const { referralCode } = useSelector((state: any) => state?.referral)
  const getShareShopText = (shopName: string, shopUrl: string): string => `
    Find ${shopName} on LoveLocal.
    Visit shop: ${shopUrl}
    Download LoveLocal App: https://llocal.onelink.me/ALsT/referral`

  const isMobile = useIsMobile()
  const storeName = shop?.name
  const storeWebUrl = `https://llocal.onelink.me/ALsT/shops?store_id=${shop?.storeId}`
  const [copied, setCopied] = useState(false)

  const socialShareMedia = [
    {
      mediaName: 'WhatsApp',
      mediaIconJsx: (
          <WhatsappShareButton
            url=" "
            title={getShareShopText((storeName ?? 'Shop'), storeWebUrl)}
          >
            <Icons
              name="SocialShareWhatsapp"
              width={isMobile ? '70px' : '50px'}
              height={isMobile ? '70px' : '50px'}
            />
          </WhatsappShareButton>
      )
    },
    {
      mediaName: 'Facebook',
      mediaIconJsx: (
          <FacebookShareButton
            url="https://www.lovelocal.in"
            {...({ quote: getShareShopText((storeName ?? 'Shop'), storeWebUrl) } as any)}
          >
            <Icons
              name="SocialShareFacebook"
              width={isMobile ? '70px' : '50px'}
              height={isMobile ? '70px' : '50px'}
            />
          </FacebookShareButton>
      )
    },
    {
      mediaName: 'Twitter',
      mediaIconJsx: (
          <TwitterShareButton
            url="https://www.lovelocal.in"
            title={getShareShopText((storeName ?? 'Shop'), storeWebUrl)}
          >
            <Icons
              name="SocialShareTwitter"
              width={isMobile ? '70px' : '50px'}
              height={isMobile ? '70px' : '50px'}
              fillOuter="#55acee"
              fillInner="#f1f2f2"
            />
          </TwitterShareButton>
      )
    },
    {
      mediaName: 'Copy Link',
      mediaIconJsx: (
          <button
            onClick={() => {
              copyToClipboard(getShareShopText((storeName ?? 'Shop'), storeWebUrl))
              //   showSuccess('COPIED')
              setCopied(true)
              setTimeout(() => { setCopied(false) }, 5000)
            }}
            className="p-0"
          >
            <Icons
              name="SocialShareCopy"
              width={isMobile ? '70px' : '50px'}
              height={isMobile ? '70px' : '50px'}
              fill="#ffebf9"
              stroke="#b8238e"
            />
          </button>
      )
    }
  ]
  return (
    <div className='w-full'>
        <div className="text-lg text-black font-bold pt-3 pl-3">Share this shop via</div>
              <div className="flex items-center justify-between">
                {socialShareMedia.map((item) => (
                  <div className="p-3 bg-white" key={item.mediaName}>
                    <div>{item.mediaIconJsx}</div>
                    <div className="text-xs text-center text-black text-opacity-50 font-bold">
                      {item.mediaName}
                    </div>
                  </div>
                ))}
        </div>
        {copied && (
                <div className="text-sm pb-6">
                  <div className="p-2 bg-pink-100 text-[#B8238E] flex flex-row gap-1">
                    <Icons
                      name="copy"
                      width="1.2rem"
                      fill={'pink'}
                    />
                    <span>
                      <span className='font-bold'>Below text is copied on your clipboard,</span>
                        paste it while sharing your on any social media.
                    </span>
                  </div>
                  <div className="p-2 bg-gray-100 break-all">
                    {getShareShopText((storeName ?? 'Shop'), storeWebUrl)}
                  </div>
                </div>
        )}
    </div>
  )
}

export default StoreSocialShare
